import React from "react";
import {abbvLocation} from "./locations/LocationNames";

export const formatStyles = {
  cellSubtext:{
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    fontWeight:'300',
    lineHeight: '1em'
  },
  sizeLabel:{
    fontSize:'0.825em',
    whiteSpace:'nowrap',
    marginLeft:'0.35em'
  },
  date:{
    display: 'inline-block',
    whiteSpace: 'nowrap',
    alignSelf:'top',
  },
  datetime:{
    display:'flex',
    gap: '0.35rem',
    alignItems: 'baseline',
    '& > div':{
      whiteSpace: 'nowrap'
    },
    '& > div:first-child':{
      fontSize:'0.80rem',
    },
    '& > div:last-child':{

    },
  },
  locationText: {
    whiteSpace:'nowrap',
  },
}

const dateFormat = new Intl.DateTimeFormat();
export function dateToString(date){
  try {
    if(date === null || date === ''){
      return '';
    }else if(typeof(date) === "string"){
      if(date.includes("T")){
        return new Date(date).toLocaleDateString();
      }else {
        return new Date(date.replace(/-/g, '/')).toLocaleDateString();
      }
    }else if (typeof(date.toLocaleDateString) === "function") {
      return date.toLocaleDateString();
    }
    return dateFormat.format(date);
  } catch (exception) {
    return '';
  }
}

export function formatDate(id, dateString, {date}, Component="div"){
  return <Component id={id} className={date} >{dateToString(dateString)}</Component>;
}

export function formatDateTime(id, dateString, {datetime, cellSubtext}, direction="row"){
  return (
    <div id={id} className={datetime} style={{flexDirection: direction}}>
      <div >{dateString ? new Date(dateString).toLocaleDateString() : ''}</div>
      <div className={cellSubtext} >{dateString ? new Date(dateString).toLocaleTimeString() : ''}</div>
    </div>);
}

export function formatLocation(id, loc, {locationText, cellSubtext}, opts={}){
  const {hideCoords=false} = opts;
  return loc ? <>
    <div id={id} className={locationText}>
      {abbvLocation(loc)}
    </div>
    {hideCoords ? null :
      <div className={cellSubtext}>
        {[loc.latitude, loc.longitude].filter(item => !!item).map(item => item.toFixed(2)).join(', ')}
      </div>
    }
  </> : null;
}

export function formatByteSize(size, {sizeLabel}){
  if(typeof(size) === 'undefined' || size === null){
    return '';
  }
  if(typeof(size) === 'string'){
    size = parseFloat(size);
  }
  if(size === 0){
    return <>{size}<span className={sizeLabel}>B</span></>
  }
  const i = Math.floor( Math.log(size) / Math.log(1024) );
  return (<>
    {(size / Math.pow(1024, i) ).toFixed(2) * 1}
    <span className={sizeLabel} >
          {['B', 'KB', 'MB', 'GB', 'TB'][i]}
        </span>
  </>);
}